export const formatToBoolean = (value: string, valueToCompare: string = 'A') => {
  return value === valueToCompare;
};
